import { ImportedObject } from "../bean/ImportedObject"; // adapte le chemin si besoin

class ImportedObjectServices {
    
  async fetchObjectFromUrl(url) {
    try {
      const requestOptions = {
            method: "GET",
            mode: 'cors',
        };
      const response = await fetch("https://app.listaki.fr/api/WS/getInfosProduit2.php?url=" + url, requestOptions)

      if (!response.ok) throw new Error("Erreur de requête");

      const data = await response.json();

      if (data && Object.keys(data).length > 0) {
        return new ImportedObject(data); // ✅ retour structuré
      } else {
        return null; // aucune info
      }
    } catch (error) {
      console.error("Erreur ImportService:", error);
      return null;
    }
  }

  async reportExtraction(key, { url, title, price, image }) {
    const response = await fetch("https://app.listaki.fr/api/WS/reportExtraction.php?key=" + key, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ url, title, price, image, source: "app" }),
    });
    if (!response.ok) throw new Error("Erreur lors de l'envoi du signalement");
    return response.json();
  }
}

export default new ImportedObjectServices();
